"use strict";

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.find");

var _utils = require("../helpers/utils");

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * DOM selectors.
 */


var selectors = {
  paginationLink: '.yotpo .yotpo-page-element',
  productName: '.yotpo .product-link'
};
document.addEventListener('DOMContentLoaded', function () {
  /**
   * Checking until yotpo testimonial widget is rendered.
   *
   * @param {Function} callback
   */
  function checkTestimonialsReady(callback) {
    var interval = setInterval(function () {
      if (!window.yotpo || window.yotpo.widgets.length === 0) {
        return;
      }

      var testimonialWidget = window.yotpo.widgets.find(function (widget) {
        return widget.settings.type === 'testimonials_custom_tab';
      });

      if (!testimonialWidget) {
        clearInterval(interval);
        callback(false);
        return;
      }

      if (testimonialWidget._state !== 'ready') {
        return;
      }

      clearInterval(interval);
      callback(testimonialWidget);
    }, 100);
  }
  /**
   * Convert all 'On N/A' to 'Click to discover more'.
   * If the length of product name is greater than 150 it is saying N/A.
   */


  function convertLongNames() {
    var productNames = _toConsumableArray(document.querySelectorAll(selectors.productName));

    productNames.forEach(function (element) {
      if (element.innerText.trim() === 'On N/A') {
        element.innerText = 'Click to discover more';
      }
    });
  }
  /**
   * Initialise component.
   */


  function init() {
    checkTestimonialsReady(function (widget) {
      if (widget === false) {
        return;
      }

      widget.sources['product-basic'].callbacks.pageChanged.push(function () {
        setTimeout(function () {
          convertLongNames();
        }, 2000);
      });
      convertLongNames();
    });
  }

  init();
});